import bindScroll from 'helpers/bindScroll';
import landscapeCarousel from 'components/landscapeCarousel';
import portraitCarousel from 'components/portraitCarousel';
import gridPortraitView from 'components/gridPortraitView';
import carouselWrapperTpl from 'templates/carousels/wrapper.tpl';
import gridPortraitWrapperTpl from 'templates/carousels/gridPortraitWrapper.tpl';
import hubPromotionCarousel from 'carousels/hubPromotionCarousel';
import spotlightCarousel from 'carousels/spotlightCarousel';
import prominentCarousel from 'carousels/prominentCarousel';
import onNowLandscapeCarousel from 'components/onNowLandscapeCarousel';
import urlHelper from 'helpers/UrlHelper';
import CollectionsHubSubNav from '../components/collectionsHubSubNav';

import {
    MODEL_CHARACTER_CAROUSEL,
    MODEL_HUB,
    MODEL_PROMOTION,
    MODEL_SHOW_MOVIE_HYBRID,
    MODEL_TRENDING,
    MODEL_TOP_SHOWS,
    MODEL_TOP_STORIES,
    MODEL_MULTICHANNEL,
    MODEL_CHANNEL,
    MODEL_VIDEO,
    MODEL_VIDEOCONFIG,
    MODEL_PROMINENT_CAROUSEL,
} from 'shared/constants';
import { formatEventTime } from 'helpers/dates';
import DMAStorageService from '../services/DMAStorageService';
import HttpService from 'services/HttpService';
import DMAService from 'services/DMAService';
import contentHighlightCarousel from '../components/highlight/carousel/ContentHighlightCarousel';

export default function hubCollectionConfigurator() {
    let objs = []; // array of non-async carousels
    let userState = CBS.Registry.user_auth ? 'rg' : 'an';
    let _regionPrefix = CBS.Registry.region.prefix;
    let isDoingAjax,
        paginatedAllLoaded = false;
    let loadMoreLimit = 20; // match 20 carousels limit from api
    let firstCategory = null;
    let currentCategory = null;
    let categoryHash = null;
    let categoryKeys = [];
    let http = new HttpService();
    let position = '0';
    let DMAStorage = new DMAStorageService();

    try {
        if (!collectionConfig) {
            return;
        }

        collectionConfig = collectionConfig.reverse();

        let belowTheFoldContainer = document.querySelector('.bottom-components');

        const isHubGridComponentEnabled = CBS.Registry.Features.hub_grid_component_enabled;

        // START A/B TEST PLGRWEB-1558 Live Sports Data Carousel
        let inSportsDataVariant =
            CBS.AbTestsConfigs?.modules?.LiveSportsDataCarousel?.inVariants ?? false;
        let displayScoresToggle = inSportsDataVariant;
        // END A/B TEST PLGRWEB-1558 Live Sports Data Carousel

        function recursiveConfigurationCarousels(collections) {
            if (collections.length > 0) {
                let carouselData = collections.pop();
                let token = carouselData.token;

                createCarouselPlaceholder(carouselData?.domId);

                carouselData.position = position;
                position = parseInt(position) + 1;

                if (
                    carouselData.model === MODEL_HUB ||
                    carouselData.model === MODEL_PROMOTION ||
                    carouselData.model === MODEL_SHOW_MOVIE_HYBRID ||
                    carouselData.model === MODEL_TRENDING ||
                    carouselData.model === MODEL_TOP_SHOWS ||
                    carouselData.model === MODEL_TOP_STORIES ||
                    carouselData.model === MODEL_CHARACTER_CAROUSEL ||
                    carouselData.model === MODEL_VIDEOCONFIG
                ) {
                    let baseEndpoint =
                        _regionPrefix +
                        '/carousels/collections/configItems/' +
                        userState +
                        '/' +
                        encodeURIComponent(token) +
                        '/offset/{offset}/limit/{limit}/';
                    baseEndpoint = urlHelper.appendBundleStatusAndPackageCode(baseEndpoint);
                    let options = {
                        endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                        params: {
                            slug: carouselData.slug,
                            sectionId: carouselData.sectionId,
                        },
                        contentHighlight: carouselData.isContentHighlightEnabled ?? false,
                        carouselPresentationStyle: carouselData.carouselPresentationStyle ?? '',
                    };

                    // START feature/PLGRWEB-1621 Browse Relocate & Display Numeric
                    if (carouselData?.hasBrowseNumericExperiment === true) {
                        options.useBuffer = false;
                    }
                    // END feature/PLGRWEB-1621 Browse Relocate & Display Numeric

                    if (
                        carouselData.carouselPresentationStyle === 'grid' &&
                        isHubGridComponentEnabled
                    ) {
                        objs.push(createWrapperGrid(carouselData, options));
                    } else {
                        objs.push(createWrapperCarousel(carouselData, options));
                    }

                    recursiveConfigurationCarousels(collections);
                } else if (
                    carouselData.model === MODEL_VIDEO ||
                    carouselData.model === MODEL_CHANNEL ||
                    carouselData.model === MODEL_MULTICHANNEL
                ) {
                    const placeholderElementId = carouselData.domId ?? '';

                    let endpoint =
                        _regionPrefix +
                        '/carousels/collections/configItems/' +
                        userState +
                        '/' +
                        encodeURIComponent(token) +
                        '/offset/0/limit/0/';

                    $.ajax({
                        url: endpoint,
                        dataType: 'json',
                        type: 'GET',
                        cache: false,
                        headers: {
                            'Cache-Control': 'no-cache',
                            Pragma: 'no-cache',
                            Expires: '0',
                        },
                    }).done(function (resp) {
                        if (resp === null) {
                            recursiveConfigurationCarousels(collections);
                            return;
                        }

                        if (carouselData.model === MODEL_VIDEO) {
                            resp = JSON.parse(resp);
                            if (!resp.success || resp.result.data.length === 0) {
                                recursiveConfigurationCarousels(collections);
                                return;
                            }

                            let group = resp.result.data;

                            group.forEach((item, index) => {
                                let title =
                                    typeof item.title !== 'undefined'
                                        ? item.title
                                              .replace(/\'+/g, '')
                                              .replace(/\s+/g, '-')
                                              .toLowerCase()
                                        : '';

                                let data = {
                                    title: title,
                                    id: item.title
                                        .replace(/\'+/g, '')
                                        .replace(/\s+/g, '-')
                                        .toLowerCase(),
                                    domId: placeholderElementId,
                                };

                                let baseEndpoint =
                                    CBS.Registry.region.prefix +
                                    '/shows/{slug}/xhr/sectionId/{sectionId}/offset/{offset}/limit/{limit}/xs/0/';

                                let options = {
                                    endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                                    params: {
                                        slug: 'hubs',
                                        sectionId: item.id,
                                    },
                                    contentHighlight:
                                        carouselData.isContentHighlightEnabled ?? false,
                                };

                                createWrapperCarousel(data, options, true);

                                if (index !== group.length - 1) {
                                    createCarouselPlaceholder(placeholderElementId);
                                }
                            });
                        }

                        if (carouselData.model === MODEL_CHANNEL) {
                            if (!resp.success || resp.result.data.length === 0) {
                                recursiveConfigurationCarousels(collections);
                                return;
                            }

                            (async () => {
                                let [dma, stationId] = DMAStorage.getDMAStationIdStringOnNow();

                                let dmaParams =
                                    dma != null && stationId != null
                                        ? `&dma=${dma}&stationId=${stationId}`
                                        : '&dma=&stationId=';

                                let channel = resp.result.data;

                                let title = carouselData.title
                                    .replace(/\'+/g, '')
                                    .replace(/\s+/g, '-');

                                let data = {
                                    title: title,
                                    id: title.toLowerCase(),
                                    domId: placeholderElementId,
                                    displayId: carouselData.displayId,
                                    recoId: carouselData.recoId,
                                };

                                let localTimeZone =
                                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                                let baseEndpoint =
                                    CBS.Registry.region.prefix +
                                    `/carousels/collections/{slug}/xhr/schedule-events/offset/{offset}/limit/{limit}/?timeZone=${localTimeZone}${dmaParams}`;

                                /**
                                 * Very specific update to Showtime hub/collecton Carousels: append bundleStatus for proper caching
                                 * TODO: Generalize as necessary where bundleStatus will change a user's carousel response
                                 * in terms of status/lock
                                 */
                                if (carouselData.slug == 'showtime') {
                                    baseEndpoint =
                                        urlHelper.appendBundleStatusAndPackageCode(baseEndpoint);
                                }

                                // START A/B TEST PLGRWEB-1558 Live Sports Data Carousel
                                if (inSportsDataVariant)
                                    baseEndpoint = baseEndpoint + '&sportsDataVariant=true';
                                if (displayScoresToggle) {
                                    // display scores toggle for the first schedule carousel only
                                    baseEndpoint = baseEndpoint + '&displayScoresToggle=true';
                                    displayScoresToggle = false;
                                }
                                // END A/B TEST PLGRWEB-1558 Live Sports Data Carousel

                                let options = {
                                    endPoint: baseEndpoint,
                                    params: {
                                        slug: channel.slug,
                                    },
                                    isChannel: true,
                                };

                                createWrapperCarousel(data, options, true); // async carousel
                            })();
                        }

                        if (carouselData.model === MODEL_MULTICHANNEL) {
                            let dmaService = new DMAService();

                            dmaService.getDMA().then((dmaObject) => {
                                let dmaParam = dmaService.getFirstDmaValue(dmaObject?.dma);
                                dmaParam = `&dma=${dmaParam}`;

                                let title = carouselData.title
                                    .replace(/\'+/g, '')
                                    .replace(/\s+/g, '-');

                                let localTimeZone =
                                    Intl.DateTimeFormat().resolvedOptions().timeZone;

                                let data = {
                                    title: title,
                                    id: title.toLowerCase(),
                                    domId: placeholderElementId,
                                    displayId: carouselData.displayId,
                                    recoId: carouselData.recoId,
                                };

                                let baseEndpoint =
                                    CBS.Registry.region.prefix +
                                    `/carousels/collections/{slug}/xhr/multichannel-events/offset/{offset}/limit/{limit}/?timezone=${localTimeZone}&title=${title}${dmaParam}`;

                                // START A/B TEST PLGRWEB-1558 Live Sports Data Carousel
                                if (inSportsDataVariant)
                                    baseEndpoint = baseEndpoint + '&sportsDataVariant=true';
                                if (displayScoresToggle) {
                                    // display scores toggle for the first schedule carousel only
                                    baseEndpoint = baseEndpoint + '&displayScoresToggle=true';
                                    displayScoresToggle = false;
                                }
                                // END A/B TEST PLGRWEB-1558 Live Sports Data Carousel

                                let options = {
                                    endPoint: baseEndpoint,
                                    params: {
                                        slug: carouselData.channelSlug,
                                    },
                                    isChannel: true,
                                    contentHighlight:
                                        carouselData.isContentHighlightEnabled ?? false,
                                };

                                objs.push(createWrapperCarousel(data, options, true)); // async carousel
                            });
                        }

                        recursiveConfigurationCarousels(collections);
                    });
                } else if (carouselData.model === MODEL_PROMINENT_CAROUSEL) {
                    let baseEndpoint =
                        _regionPrefix +
                        '/carousels/collections/configItems/' +
                        userState +
                        '/' +
                        encodeURIComponent(token) +
                        '/offset/{offset}/limit/{limit}/';
                    baseEndpoint = urlHelper.appendBundleStatusAndPackageCode(baseEndpoint);

                    let options = {
                        endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                        params: {
                            slug: carouselData.slug,
                            sectionId: carouselData.sectionId,
                        },
                        contentHighlight: carouselData.isContentHighlightEnabled ?? false,
                    };

                    carouselData.options = options;
                    carouselData.customClass = 'prominent-carousel-wrapper';

                    let wrapper = $(carouselWrapperTpl(carouselData));

                    replaceCarouselPlaceholder(wrapper.get(0), carouselData.domId);

                    objs.push(new prominentCarousel(wrapper, carouselData));

                    recursiveConfigurationCarousels(collections);
                } else {
                    recursiveConfigurationCarousels(collections);
                }
            } else {
                const filteredArray = objs.filter((item) => item !== undefined);
                new bindScroll(filteredArray);
                objs = [];
            }
        }

        function createCarouselPlaceholder(carouselId) {
            if (!carouselId || !belowTheFoldContainer) return;
            const carouselPlaceholder = document.createElement('div');
            carouselPlaceholder.id = carouselId;
            belowTheFoldContainer.appendChild(carouselPlaceholder);
        }

        function replaceCarouselPlaceholder(wrapper, carouselId) {
            if (!wrapper || !carouselId || !belowTheFoldContainer) return;
            const tempCarouselPlaceholder = document.getElementById(carouselId);
            if (!tempCarouselPlaceholder) return;
            belowTheFoldContainer.replaceChild(wrapper, tempCarouselPlaceholder);
        }

        function createWrapperCarousel(data, options, swapAsyncCarouselElement = false) {
            data.baseEndpoint = options.endPoint;

            data.customClass = '';
            if (data.carouselPresentationStyle === 'spotlight') {
                data.customClass = 'spotlight-carousel';
            } else if (data.model === 'promotion' && data.carouselPresentationStyle === 'default') {
                data.customClass = 'hub-promotion-carousel-container';
            } else if (data.model === MODEL_CHARACTER_CAROUSEL) {
                data.customClass = 'kids-carousel';
            }

            let wrapper = $(
                carouselWrapperTpl({
                    recoId: data.recoId,
                    displayId: data.displayId,
                    title: data.title,
                    carouselId: data.carouselId ? data.carouselId : '',
                    carouselPresentationStyle: data.carouselPresentationStyle ?? '',
                    position: data.position ? data.position : '',
                    id: data.title.replace(/\'+/g, '').replace(/\s+/g, '-').toLowerCase(),
                    model: data.model,
                    rankModel: data.rankModel ? data.rankModel : '',
                    customClass: data.customClass,
                    isContentHighlightEnabled: data.isContentHighlightEnabled,
                }),
            );

            let carouselElement = wrapper.find('.js-video-carousel');

            let obj = {
                wrapper: carouselElement,
                init: function () {
                    wrapper.on('init', () => {
                        carouselElement.removeClass('hidden');
                    });

                    wrapper.on('setPosition', () => {
                        wrapper.ellipsify();
                    });

                    if (data.model === 'promotion') {
                        if (data.carouselPresentationStyle === 'spotlight') {
                            let $promoCarousel = new spotlightCarousel(wrapper, data);
                            $promoCarousel.init();
                        } else if (data.carouselPresentationStyle === 'default') {
                            let $promoCarousel = new hubPromotionCarousel(wrapper, data);
                            $promoCarousel.init();
                        }
                    } else if (data.orientation === 'portrait') {
                        if (options.contentHighlight) {
                            contentHighlightCarousel({
                                parentContainer: carouselElement[0],
                                options: options,
                                orientation: data.orientation,
                            });
                        } else {
                            portraitCarousel({
                                parentContainer: carouselElement,
                                options: options,
                            });
                        }
                    } else {
                        if (options.isChannel) {
                            wrapper.on('videoDataLoad', (e, result) => {
                                result?.data?.forEach((item) => {
                                    if (!item.isLive) {
                                        const time = new Date(parseInt(item.startTimestamp));
                                        item.scheduleBadgeText = formatEventTime(time);
                                    }
                                });
                            });
                            onNowLandscapeCarousel({
                                parentContainer: carouselElement,
                                options: options,
                                size: 'small',
                            });
                        } else {
                            if (options.contentHighlight) {
                                contentHighlightCarousel({
                                    parentContainer: carouselElement[0],
                                    options: options,
                                    orientation: data.orientation,
                                });
                            } else {
                                landscapeCarousel({
                                    parentContainer: carouselElement,
                                    options: options,
                                });
                            }
                        }
                    }
                },
            };

            replaceCarouselPlaceholder(wrapper.get(0), data?.domId);

            if (swapAsyncCarouselElement) {
                new bindScroll([obj]);
                return;
            }

            return obj;
        }

        function createWrapperGrid(data, options) {
            let wrapper = $(
                gridPortraitWrapperTpl({
                    recoId: data.recoId,
                    displayId: data.displayId,
                    title: decodeURIComponent(data.title.replace(/\+/g, ' ')),
                    carouselId: data.carouselId ? data.carouselId : '',
                    carouselPresentationStyle: data.carouselPresentationStyle ?? '',
                    position: data.position ? data.position : '',
                    id: data.title.replace(/\'+/g, '').replace(/\s+/g, '-').toLowerCase(),
                    model: data.model,
                    rankModel: data.rankModel,
                    isContentHighlightEnabled: data.isContentHighlightEnabled,
                }),
            );

            let gridElement = wrapper.find('.grid-portrait-wrapper');

            let obj = {
                wrapper: gridElement,
                init: function () {
                    wrapper.on('init', () => {
                        gridElement.removeClass('hidden');
                    });

                    wrapper.on('setPosition', () => {
                        wrapper.ellipsify();
                    });

                    try {
                        options.carouselModel = data.model ?? '';
                        gridPortraitView({
                            parentContainer: gridElement,
                            options: options,
                        });
                    } catch (e) {
                        console.error(`${options.params.slug} grid failed to load`);
                    }
                },
            };

            replaceCarouselPlaceholder(wrapper.get(0), data?.domId);

            return obj;
        }

        function loadMoreCarousels() {
            if (isDoingAjax || paginatedAllLoaded) {
                return false;
            }
            isDoingAjax = true;
            let newOffset = belowTheFoldContainer.getAttribute('data-offset'),
                limit = belowTheFoldContainer.getAttribute('data-limit'),
                slug = belowTheFoldContainer.getAttribute('data-slug');
            // get next batch of paginated results
            $.ajax({
                url: `/carousels/collections/${slug}/loadmore/xhr/start/${newOffset}/`,
                dataType: 'json',
                type: 'GET',
                cache: false,
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                    Expires: '0',
                },
                success: function (resp) {
                    // increment offset by limit
                    belowTheFoldContainer.setAttribute('data-offset', newOffset + limit);
                    // has collections
                    if (resp.length) {
                        // set new collection config data
                        collectionConfig = resp.reverse();
                        // init new carousels
                        recursiveConfigurationCarousels(collectionConfig);
                    } else {
                        paginatedAllLoaded = true;
                    }
                },
                complete: function () {
                    isDoingAjax = false;
                },
                error: function () {
                    console.log('Something went wrong getting collections!');
                },
            });
        }

        function changeActiveSubnavItem(newHash) {
            if (window.impressionTracking) {
                window.impressionTracking.needToDoInitialTracking = true;
            }
            let oldItem = document.querySelector('ul.subnav__items a.active');
            oldItem?.classList.remove('active');
            let newItem = document.querySelector(
                `ul.subnav__items a[data-category='${CBS.Registry.region.prefix}/collections/#${newHash}']`,
            );
            newItem?.classList.add('active');
        }

        function getNewCategory(newCategory) {
            if (!categoryKeys.includes(newCategory)) {
                newCategory = firstCategory;
            }
            if (newCategory === currentCategory) {
                return;
            }
            changeActiveSubnavItem(newCategory);
            getCollectionCategory(newCategory);
            let newSlug = collectionCategories[categoryKeys.indexOf(newCategory)].slug;
            belowTheFoldContainer?.setAttribute('data-slug', newSlug);
        }

        function getCollectionCategory(hash) {
            let url = `/carousels/collections/xhr/category/${hash}/`;
            http.doGet(url)
                .then((response) => {
                    if (response.success) {
                        belowTheFoldContainer.innerHTML = '';
                        collectionConfig = response.data.result.reverse();
                        recursiveConfigurationCarousels(collectionConfig);
                        currentCategory = hash;
                        __hub = response.data.hubObj;
                        updateUtagData();
                        centerSubnavHashItem(hash);
                    }
                })
                .catch((e) => {
                    console.log('Something went wrong getting collection categories!');
                });
        }

        function centerSubnavHashItem(hash) {
            setTimeout(() => {
                const subnavList = document.querySelector('ul[data-ci="subnav"]');
                if (subnavList) {
                    const matchingLink = subnavList.querySelector(`a[href$="#${hash}"]`);
                    if (matchingLink) {
                        matchingLink.scrollIntoView({
                            behavior: 'smooth',
                            inline: 'center',
                            block: 'nearest',
                        });
                    }
                }
            }, 100); // slight delay to allow DOM update
        }

        function formatHash(hash) {
            hash = hash.substring(1).toLowerCase();
            if (hash === '') {
                hash = firstCategory;
            }
            return hash;
        }

        function hashChangeHandler() {
            categoryHash = formatHash(window.location.hash);
            getNewCategory(categoryHash);
            setPageName(categoryHash);
        }

        function setPageName(categoryHash) {
            collectionPageName = `/hub_browse/${categoryHash}`;
            collectionDefault = categoryHash === firstCategory;
        }

        function updateUtagData() {
            if (CBS?.Tracking?.utag_data) {
                CBS.Tracking.utag_data.hubId = __hub?.id ?? '';
                CBS.Tracking.utag_data.hubSlug = __hub?.hubSlug ?? '';
                CBS.Tracking.utag_data.title = __hub?.title ?? '';
            }
        }

        if (typeof collectionCategories === 'undefined') {
            // init carousels
            recursiveConfigurationCarousels(collectionConfig);
        } else {
            // set up collections browse page
            collectionCategories.forEach((category) => categoryKeys.push(category.itemKey));
            firstCategory = categoryKeys[0];
            categoryHash = formatHash(window.location.hash);
            setPageName(categoryHash);

            if (categoryHash === firstCategory) {
                // init carousels
                recursiveConfigurationCarousels(collectionConfig);
                currentCategory = categoryHash;
            } else {
                getNewCategory(categoryHash);
            }

            window.addEventListener('hashchange', hashChangeHandler, false);
            new CollectionsHubSubNav();
        }

        // set data attributes on container
        belowTheFoldContainer.setAttribute('data-offset', loadMoreLimit);
        belowTheFoldContainer.setAttribute('data-limit', loadMoreLimit);

        // append load more element
        let loadMoreElement = document.createElement('div');
        loadMoreElement.classList.add('bottom-components-load-more');
        belowTheFoldContainer.after(loadMoreElement);

        // display the active sub nav item
        let subNav = document.getElementById('subnav');
        if (subNav) {
            let subNavItems = document.querySelector('.subnav__items');
            let activeSubnav = document.querySelector('.subnav__items li a.active');
            if (activeSubnav) {
                let offset = activeSubnav.getBoundingClientRect();
                let compensatePageSize = window.innerWidth / 2 - activeSubnav.offsetWidth / 2;
                subNavItems.scrollLeft = offset.left + window.scrollX - compensatePageSize;
            }
        }

        // seems to need timeout for safari...
        setTimeout(function () {
            // load more when scrolled to $loadMoreComponents
            const intersectionObserver = new IntersectionObserver((entries) => {
                if (entries[0].intersectionRatio <= 0) return;
                loadMoreCarousels();
            });
            intersectionObserver.observe($('.bottom-components-load-more')[0]);
        }, 800);
    } catch (e) {
        console.log('Hub Configurator - ' + e);
    }
}
